<template>
    <v-row>
        <!--<v-col  sm="3" md="4" xl="4"  class="text-center">
            <h5 class="green--text">Line Message {{usage}}/{{total}}</h5>
        </v-col> 
        <v-divider vertical style="margin-right:5px;"></v-divider>
        <v-col >
            <v-progress-linear
                v-model="percentUsage"
                height="25"
                striped
            >
            <h6>{{ percentUsage }}% </h6>
            </v-progress-linear>
        </v-col>-->
    </v-row>
</template>

<script>

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
    props: ['station_code'],
    data: () => ({
        percentUsage: 0,
        usage: 0,
        total: 0,
    }),
    methods: {
        reload() {
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.station.get_stationdetail,{station_code:this.station_code},{ headers: Staff.getTokenHeader()})
            .then(response => {
                this.usage = response.data.count_noti
                this.total = response.data.line_message_count
                this.percentUsage = Math.floor((this.usage/this.total)*100)
                this.$store.commit('finishLoading',que)
            })
            .catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        }
    },
    mounted : function () {
        this.reload()
    } 
}
</script>